

const toastPosition = {
    top_left:       'top-left',
    top_center:     'top-center',
    top_right:      'top-right',
    middle_left:    'middle-left',
    middle_center:  'middle-center',
    middle_right:   'middle-right',
    bottom_left:    'bottom-left',
    bottom_center:  'bottom-center',
    bottom_right:   'bottom-right',
    custom:         ''
};

const toastPositionClass = {};
toastPositionClass[toastPosition.top_left] = 'toast-top-left';
toastPositionClass[toastPosition.top_center] = 'toast-top-center';
toastPositionClass[toastPosition.top_right] = 'toast-top-right';
toastPositionClass[toastPosition.middle_left] = 'toast-middle-left';
toastPositionClass[toastPosition.middle_center] = 'toast-middle-center';
toastPositionClass[toastPosition.middle_right] = 'toast-middle-right';
toastPositionClass[toastPosition.bottom_left] = 'toast-bottom-left';
toastPositionClass[toastPosition.bottom_center] = 'toast-bottom-center';
toastPositionClass[toastPosition.bottom_right] = 'toast-bottom-right';
toastPositionClass[toastPosition.custom] = '';

const defaultOptions = {
    animation:      true,
    autohide:       true,
    delay:          3000,
    position:       'top-right',
    containerClassList: [],
    toastClassList:     ['bg-primary', 'text-light'],
    headerClassList:    [],
    bodyClassList:      [],
    bodyContent:    '',
    headerContent: '',
    datasetList:     [],
    closeButton:    true,
    hideOthers:     false,
    onShow:         null,
    onShown:        null,
    onHide:         null,
    onHidden:       null,
    autoShow:       false
};

export const { top_left, top_center, top_right, middle_left, middle_center, middle_right, bottom_left, bottom_center, bottom_right } = toastPosition;

export class Toast
{

    constructor(options = {})
    {
        this.returnObj = {

        };
        this.toastElem = null;

        for (const [key, value] of Object.entries(options)) {
            // remove any invalid options
            if (Object.keys(defaultOptions).indexOf(key) === -1) {
                delete options[key];
                continue;
            }
        }

        for (const [defaultOptionsKey, defaultOptionsValue] of Object.entries(defaultOptions)) {
            if (['containerClassList', 'toastClassList', 'headerClassList', 'bodyClassList'].indexOf(defaultOptionsKey) != -1) {
                if (typeof options[defaultOptionsKey] === 'string') {
                    options[defaultOptionsKey] = [options[defaultOptionsKey]];
                }
                if (typeof defaultOptionsValue === 'object' && typeof options[defaultOptionsKey] === 'object') {
                    // handle classList arrays
                    options[defaultOptionsKey].forEach(optionsClassListValue => {
                        const dashIdx = optionsClassListValue.indexOf('-');
                        // remove default options classlist items that are similar to those in options classlist value
                        defaultOptionsValue.forEach(defaultOptionsClassListValue => {
                            if (defaultOptionsClassListValue === optionsClassListValue || (dashIdx !== -1 && defaultOptionsClassListValue.substr(0, dashIdx) == optionsClassListValue.substr(0, dashIdx))) {
                                const idx = defaultOptionsValue.indexOf(defaultOptionsClassListValue);
                                defaultOptionsValue.splice(idx, 1);
                            }
                        });
                     });
                    // merge any remaining default option classlist items into passed options
                    options[defaultOptionsKey] = options[defaultOptionsKey].concat(defaultOptionsValue);
                } else {
                    options[defaultOptionsKey] = defaultOptionsValue;
                }
             } else {
                options[defaultOptionsKey] = options[defaultOptionsKey] || defaultOptionsValue;
            }
        }

        this.create(options);
        this.options = options;
        if (this.options.autoShow) {
            this.show();
        }
    }

    create(options)
    {

        this.toastElem = document.createElement('div');
        this.toastElem.classList.add('toast');
        options.toastClassList.forEach(elem => {
            this.toastElem.classList.add(elem);
        });
        this.toastElem.setAttribute('role', 'alert');
        this.toastElem.setAttribute('aria-live', 'assertive');
        this.toastElem.setAttribute('aria-atomic', 'true');

        options.datasetList.forEach(dataset => {
            this.toastElem.dataset[dataset.key] = dataset.value;
        });


        const toastHeaderElem = this.toastElem.appendChild(document.createElement('div'));
        toastHeaderElem.classList.add('toast-header');
        options.headerClassList.forEach(elem => {
            toastHeaderElem.classList.add(elem);
        });
        const headerTextElem = toastHeaderElem.appendChild(document.createElement('strong'));
        headerTextElem.classList.add('me-auto');
        headerTextElem.textContent = options.headerContent;

        if (options.closeButton) {
            const closeButton = toastHeaderElem.appendChild(document.createElement('button'));
            closeButton.classList.add('btn-close');
            closeButton.setAttribute('type', 'button');
            closeButton.setAttribute('aria-label', 'Close');
            closeButton.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                this.hide();
            });
        }

        // setup a click event handler which brodcases a message to the document
        this.toastElem.addEventListener('click', (event) => {
            const customEvent = new CustomEvent('toast-notification-click', {
                bubbles: true,
                cancelable: true,
                detail: {
                    originalEvent: event
                }
            });
            document.body.dispatchEvent(customEvent);
        });

        const toastBodyElem = this.toastElem.appendChild(document.createElement('div'));
        toastBodyElem.classList.add('toast-body');
        options.bodyClassList.forEach(elem => {
            toastBodyElem.classList.add(elem);
        });
        toastBodyElem.innerHTML = options.bodyContent;
    }
    show()
    {
        let toastContainerElem = document.body.querySelector('.toast-container');
        if (!toastContainerElem) {
            toastContainerElem = document.createElement('div');
            toastContainerElem.classList.add('toast-container');
            this.options.containerClassList.forEach(elem => {
                toastContainerElem.classList.add(elem);
            });
            if (this.options.position && toastPositionClass[this.options.position]) {
                toastContainerElem.classList.add(toastPositionClass[this.options.position]);
            }
            const dialog = document.querySelector('dialog');
            if (dialog && dialog.hasAttribute('open')) {
                dialog.appendChild(toastContainerElem);
            } else {
                document.body.appendChild(toastContainerElem);
            }
        }

        if (this.options.hideOthers) {
            const currentToasts = toastContainerElem.querySelectorAll('.toast');
            const hideAndShow = () => {
                currentToasts.forEach(elem => {
                    if (elem._toastInstance) {
                        elem._toastInstance.hide();
                    }
                });
                this.showToast(toastContainerElem);
            };
    
            if (typeof this.options.hideOthers === "number") {
                setTimeout(hideAndShow, this.options.hideOthers);
            } else if (Boolean(this.options.hideOthers)) {
                hideAndShow();
            }
        } else {
            this.showToast(toastContainerElem);
        }
    }

    showToast(toastContainerElem)
    {
        toastContainerElem.appendChild(this.toastElem);
        this.toastElem._toastInstance = this;
    
        this.dispatchEvent('show');
        if (typeof this.options.onShow === 'function') {
            this.options.onShow();
        }
    
        // Force reflow so the transition plays
        this.toastElem.offsetHeight;
        this.toastElem.classList.add('show');
    
        if (typeof this.options.onShown === 'function') {
            this.options.onShown();
        }
    
        if (this.options.autohide) {
            this.autohideTimeout = setTimeout(() => this.hide(), this.options.delay);
        }
    }

    hide()
    {
        if (typeof this.options.onHide === 'function') {
            this.options.onHide();
        }
    
        if (this.autohideTimeout) {
            clearTimeout(this.autohideTimeout);
            this.autohideTimeout = null;
        }
    
        this.toastElem.classList.remove('show');
    
        let cleaned = false;
        const cleanup = () => {
            if (cleaned) {
                return;
            }
            cleaned = true;
            if (typeof this.options.onHidden === 'function') {
                this.options.onHidden();
            }
            const containerElem = this.toastElem.closest('.toast-container');
            this.toastElem.remove();
            if (containerElem && !containerElem.hasChildNodes()) {
                containerElem.remove();
            }
        };
    
        if (this.options.animation) {
            this.toastElem.addEventListener('transitionend', cleanup, { once: true });
            // Fallback if transitionend doesn't fire
            setTimeout(cleanup, 500);
        } else {
            cleanup();
        }
    }

    dispatchEvent(eventName)
    {
        this.toastElem.dispatchEvent(new CustomEvent(`toast.${eventName}`));
    }    
}
